import { Table } from 'antd';
import type {
  MeasurementItemDisplay,
  MeasurementGroupDisplay,
} from '../../../types/reportDetail';
import styles from './MeasurementCard.module.css';

interface MeasurementCardProps {
  group: MeasurementGroupDisplay;
}

const columns = [
  {
    title: '',
    key: 'label',
    // Marker sits right after the label. The sparkle matches the worksheet's
    // AI marker (AP-764) so one glyph means "AI-derived" across the app.
    render: (_: unknown, record: MeasurementItemDisplay) => (
      <span className={styles.labelCell}>
        {record.label}
        {record.isAIValue && (
          <span
            className={styles.aiMark}
            role="img"
            aria-label="AI-derived value"
            title="AI-derived value"
          >
            ✦
          </span>
        )}
      </span>
    ),
  },
  { title: '', dataIndex: 'value', key: 'value', align: 'right' as const },
  { title: '', dataIndex: 'unit', key: 'unit', align: 'left' as const },
  {
    title: '',
    key: 'range',
    align: 'right' as const,
    render: (_: unknown, record: MeasurementItemDisplay) => (
      <span className={styles.rangePlaceholder}>
        {record.normalRange || '—'}
      </span>
    ),
  },
];

export default function MeasurementCard({ group }: MeasurementCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.titleRow}>
        <span className={styles.accent} />
        <span className={styles.title}>{group.groupLabel}</span>
        <span className={styles.normalRangeHeader}>Normal Range</span>
      </div>
      <Table
        className={styles.table}
        size="small"
        pagination={false}
        showHeader={false}
        dataSource={group.items}
        columns={columns}
        rowKey="key"
      />
    </div>
  );
}
